import store from '@/store';
const routes = [
	{
		path: '/Pallets',
		name: 'pallets',
		component: require('@/views/pallets/Index.vue').default,
		meta: {
			name: 'Control de Pallets',
			requiresToken: true
		},
		beforeEnter: (to, from, next) => {
			const user = store.state.Auth.user;
			if (!user) {
				store.dispatch('Auth/me');
			}
			next();
		}
	}
];
export default routes;
